import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Home, Library, Gallery } from "./Pages";
import { Navbar } from "./Components";
import "./App.css";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/library" element={<Library />}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
